/*Junais  02-04-2023*/
import * as types from "../actions/actiontype";
import * as constants from "../constants";

const initialState = {
  showReport: false,
  //props
    reportOptions: null, 
  //
  reportId: null,
  reports: null,
  reportUrl: null,
};
initialState.modalsState = {
  paramIdModel: null,
}
initialState.paramId=null;
export default function reportEngineReducer(state = initialState, action) {
  switch (action.type) {
    case types.GET_REPORTS_END: {
      let {data, reportOption} = action.payload;
      return {
        ...state,
        reports: data,
        reportOptions: reportOption,
        showReport: true,
      };
    }
    /* case types.GET_REPORT_PARAMS_END: {
      let { data, reportId, uiParams } = action.payload;
      let { reportContext, reportParams } = data;
  
      const updateReport = state.reports.map((report) => {
        if (report.reportId === reportId) {
          return { ...report, reportContext, reportParams };
        }
        return report;
      });

      return {
        ...state,
        reports: updateReport,
      };
    }*/
    case types.GET_REPORT_PARAMS_END: {
      const { data, reportId } = action.payload;
      const { reportContext, reportParams } = data;
      let uiParams = state.reportOptions.uiParams
      if (uiParams) {
        const updatedContextParamValue = reportContext.paramValues.map(
          (paramValue) => {
            const param = reportParams.find(
              (param) => param.controlType === constants.PARAM_CONTROL_TYPE_PARAM && param.paramId === paramValue.paramId
            );
            if (param && uiParams[paramValue.name]!==undefined) {
              return {
                ...paramValue,
                value: '' + uiParams[paramValue.name] 
              };
            }
            return paramValue;
          }
        );
        let updatedReports = state.reports.map((report) => {
          if (report.reportId === reportId) {
            return {
              ...report,
              reportParams,
              reportContext: {
                ...reportContext,
                paramValues: updatedContextParamValue,
              },
            };
          }
          return report;
        });
        return {
          ...state,
          reports: updatedReports,
        };
      } else {
        const updateReport = state.reports.map((report) => {
          if (report.reportId === reportId) {
            return { ...report, reportContext, reportParams };
          }
          return report;
        });

        return {
          ...state,
          reports: updateReport,
        };
      }
    }
    /* case types.GET_REPORT_PARAMS_END: {
      // Extract relevant data from the action payload
      const { data, reportId, uiParams } = action.payload;
      const { reportContext, reportParams } = data;

      // Filter out non-param control types from the report params
      const params = reportParams.filter(param => param.controlType === constants.PARAM_CONTROL_TYPE_PARAM);

      // Update parameter values in the report context
      const updatedContextParamValue = reportContext.paramValues.map(param => {
        const paramValue = params.find(p => p.paramId === param.paramId);
        if (paramValue && uiParams[paramValue.name] !== undefined) {
          return {
            ...param,
            value: `'${uiParams[paramValue.name]}'`,
          };
        }
        return param;
      });

      // Update the reports array with the new report object
      const updatedReports = state.reports.map(report => {
        if (report.reportId === reportId) {
          return {
            ...report,
            reportParams,
            reportContext: {
              ...reportContext,
              paramValues: updatedContextParamValue,
            },
          };
        }
        return report;
      });

            // Return a new state object with the updated reports array
            return {
              ...state,
              reports: updatedReports,
            };

     }*/
    case types.HANDLE_PARAM_CHANGE: {
      const { paramId, value, reportId } = action.payload;
      const updatedReports = state.reports.map((report) => {
        if (report.reportId === reportId) {
          const updatedParamValues = report.reportContext.paramValues.map(
            (paramValue) => {
              if (paramValue.paramId === paramId) {
                return { ...paramValue, value };
              }
              return paramValue;
            }
          );
          const updatedReportContext = {
            ...report.reportContext,
            paramValues: updatedParamValues,
          };
          return { ...report, reportContext: updatedReportContext };
        }
        return report;
      });
      return {
        ...state,
        reports: updatedReports,
      };
    }
    case types.HANDLE_RADIO_BTN_CHANGE: {
      let { reportId, value } = action.payload;
      // reset toggle value
      const updatedReports = state.reports.map((report) => {
        return { ...report, isChecked: false };
      });
      // update current toggle value
      const updatedReport = updatedReports.map((report) => {
        if (report.reportId === reportId) {
          return { ...report, isChecked: value };
        }
        return report;
      });

      return {
        ...state,
        reportId: reportId,
        reports: updatedReport,
      };
    }

    case types.HANDLE_CHECK_BOX_CHANGE: {
      let { reportId, value } = action.payload;
      // update isChecked only for isDocumentPrintYn = "N"
      const updatedReports = state.reports.map((report) => {
        if (report.isDocumentPrintYN === "N") {
          return { ...report, isChecked: false };
        }
        return report;
      });
      //update currentvalue
      const updatedReport = updatedReports.map((report) => {
        if (report.reportId === reportId) {
          return { ...report, isChecked: value };
        }
        return report;
      });

      return {
        ...state,
        reportId: reportId,
        reports: updatedReport,
      };
    }
    case types.GET_REPORT_PARAM_VALUE_END: {
      const { reportParams } = action.payload;
      const report = state.reports.find((p) => p.reportId === state.reportId);
      const updatedReportParams = report.reportParams.map((param) => {
        const updatedParam = reportParams.find(
          (p) => p.paramId === param.paramId
        );
        return updatedParam ? updatedParam : param;
      });
      const updatedReport = { ...report, reportParams: updatedReportParams };
      const updatedReports = state.reports.map((p) =>
        p.reportId === report.reportId ? updatedReport : p
      );
      return { ...state, reports: updatedReports };
    }
    case types.GET_REPORT_URL_END: {
      let reportUrl = action.payload;
      return {
        ...state,
        reportUrl: reportUrl,
      };
    }
    case types.CLOSE_REPORT:{
      return{
        ...state,
        showReport: false
      }
    }
    case types.RESET_REPORT:{
      let updatedReports = state.reports.map(report => {
        return { ...report, isChecked: false };
      })
      return {
        ...state, 
        reports: updatedReports
      }
    }

    case types.UPDATE_PARAM_ID: {
      return {
        ...state,
        paramId: action.payload.value
      }
    }

    case types.UPDATE_MODAL_DISPLAY_STATE_REPORT_ENGINE: {
      return {
        ...state,
        modalsState: {
          ...state.modalsState,
          [action.payload.name]: action.payload.value
        }
      }
    }

    default:
      return state;
  }
}
